import React, { useEffect, useState } from "react";
import Head from 'next/head';
import { getCatelouge } from "../api.services.js/catalouge";
import Link from "next/link";
import Button from 'react-bootstrap/Button';
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { Container } from "react-bootstrap";
import { useRouter } from "next/router";

export const getServerSideProps = async () => {
    let {data} = await getCatelouge({})
    return {
        props: { data : data ? data : null },
    };
};

const Catalouge = (props) => {
  const router = useRouter()
  const [collections, setCollections] = useState(props.data.download_catalogue.areacollections);
  const [category, setCategory] = useState(props.data.download_catalogue.category);
  const [filterData, setFilterData] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("North, Central & East");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [activeRegion, setActiveRegion] = useState(collections[1].area_name); 
  const [activeCategory, setActiveCategory] = useState("All"); 

  useEffect(() => {
    filterByCategory();
  }, [selectedRegion, selectedCategory]);

  const filterByCategory = async () => {
    setFilterData(
      collections
        .filter((curr) => curr.area_name === selectedRegion)[0]
        ?.categorycollection?.filter((obj) => obj.category_name === selectedCategory)[0]
        .categorydata
    );
  };

  const breadCrumbSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [{
          "@type": "ListItem", 
          "position": 1, 
          "name": "Home",
          "item": "https://www.orientbell.com"
        },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "Download Catalogue",
        "item": "https://www.orientbell.com/download-catalogue"
      }]
      }`
    }
  }

  return (
    <>
    <Head>
      <title>Download Tiles Catalogue PDF - Orientbell Tiles</title>
    <meta name="title" content="Download Tiles Catalogue PDF - Orientbell Tiles"/>
    <meta name="description" content="Download Orientbell wall and floor tiles catalogue for kitchen, bathroom and more. View tile collections like fusion and 3rd fire wall tiles collection."/>
    <meta name="keywords" content="tiles catalogue, tiles catalogue pdf, orient tiles catalogue, wall tiles catalogue pdf, download tile catalogue, floor tiles catalogue, wall tiles catalogue, tiles collection"/>
    <script type="application/ld+json" dangerouslySetInnerHTML={ breadCrumbSchema()}/>
    </Head>
    <Container>
    <Breadcrumb>
		<Breadcrumb.Item href='/'>Home</Breadcrumb.Item>
		<Breadcrumb.Item href='#'>Download Catalogue</Breadcrumb.Item>
		</Breadcrumb>
        <h1>Tiles Catalogue</h1>
      <div className="download_catalog_page flex-css">
        <nav>
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            {collections.map((element, index) => {
              if (index === 0) return collections[1];
             if (index === 1) return collections[0];
             else return element
            }).map((item, index) => (
              <button key={index}  className={`nav-link ${activeRegion === item.area_name ? 'active' : ''}`}
                id={`nav-${item.area_name}-tab`}
                data-bs-toggle="tab"
                data-bs-target={`#nav-${item.area_name}`}
                type="button"
                role="tab"
                aria-controls={`nav-${item.area_name}`}
                aria-selected={activeRegion === item.area_name}
                onClick={() => {
                  if(item.area_name=="Sectoral"){
                    setSelectedCategory("All");
                  }
                  setSelectedRegion(item.area_name);
                  setActiveRegion(item.area_name);
                }}
              >
                <div className="catalog_download_btn">
                  <div className="img">
                    <img src="../room.png" alt="Icon" />
                  </div>
                  <p>{item?.area_name}</p>
                </div>
              </button>
            ))}
            <button
            style={{border:'none', marginLeft:"15px"}}
                data-bs-toggle="tab"
                type="button"
                role="tab"
                onClick={(e) => {
                  e.preventDefault()
                  router.push('/download-export-catalogue')
                }}
              >
                <div className="catalog_download_btn">
                  <div className="img">
                    <img src="../room.png" alt="Icon" />
                  </div>
                  <p>Exports</p>
                </div>
              </button>
          </div>
        </nav>
        <div className="dr_download_data">
          <div className="tab-content" id="nav-tabContent">
            <div className={`tab-pane fade show ${activeRegion === "South & West" ? 'active' : ''}`} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab" tabIndex="0"></div>
            {selectedRegion !== "Sectoral" && (
              <div className="download_content_data">
                <Button variant={`outline-secondary ${activeCategory === category[3].value ? 'active' : ''}`} onClick={() => {
                  setSelectedCategory(category[3].value);
                  setActiveCategory(category[3].value);
                }}>{category[3].value}</Button>
                <Button variant={`outline-secondary ${activeCategory === category[1].value ? 'active' : ''}`} onClick={() => {
                  setSelectedCategory(category[1].value);
                  setActiveCategory(category[1].value);
                }}>{category[1].value}</Button>
                <Button variant={`outline-secondary ${activeCategory === category[0].value ? 'active' : ''}`} onClick={() => {
                  setSelectedCategory(category[0].value);
                  setActiveCategory(category[0].value);
                }}>{category[0].value}</Button>
                <Button variant={`outline-secondary ${activeCategory === category[2].value ? 'active' : ''}`} onClick={() => {
                  setSelectedCategory(category[2].value);
                  setActiveCategory(category[2].value);
                }}>{category[2].value}</Button>
              </div>
            )}
          </div>
          <div className="download_content_brifdata">
            {filterData?.length > 0 &&
              filterData?.map((item, index) => {
                return (
                  <div key={index} className="catalog_data">
                    <div key={index}>
                      {/* <Link href={`${item.url_key.split('/')[3]}`}> */}
                      <Link href={item.pdf} download target="_blank">
                        <img src={item.image} alt="Item Image" />
                      </Link>
                      <div className="flex-css">
                        {item.title}
                        <Link href={item.pdf} download target="_blank">
                          <img src="../download.png" alt="Download Icon" />
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </Container>
   
    </>
  );
};

export default Catalouge;
